import { of } from "rxjs";
import { actionCheckGoldConfirmationNeeded, } from "./actionBuyWithGold";
export var pathRequestBuyWithGold = function (action, state$, deps) {
    return of(actionCheckGoldConfirmationNeeded(action.requiredGold, action.onProcessConfirmed, action.onProcessDenied, action.onConfirmationNeeded, action.onProcessPreConfirm));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/buy-with-gold/pathRequestBuyWithGold.ts
// module id = 1791
// module chunks = 3